import { render } from "./list.vue?vue&type=template&id=152d794a"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=152d794a&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__